import React from 'react';
import PropTypes from 'prop-types';
import css from './StorePurchase.module.css';

import { FormattedMessage } from 'react-intl';
import { intlShape } from '../../../../util/reactIntl';
import { CartOrderSummary } from '../';
import { Button, SecondaryButton } from '../../../../components';
// Weight is hardcoded as the ranges will still be implemented, once they have been we can move to
// having the weight to be
const weight = 1;

function StorePurchase({
  purchaseData,
  country,
  removeItem,
  editAmount,
  handleOpenModal,
  sellerId,
  intl,
  currency,
  shippingCost,
  handleStorePurchase,
  currentUser,
}) {
  return (
    <div className={css.root}>
      <div className={css.container}>
        <div className={css.productsContainer}>
          <h2 className={css.sellerName}>
            <div className={css.titleImage}>
              <img
                className={css.storeIcon}
                src={purchaseData.sellerImage}
                alt={purchaseData.sellerName}
              />
            </div>
            <div className={css.title}>{purchaseData.sellerName}</div>
            <a
              className={css.sellerNameValue}
              href={`/u/${purchaseData.sellerId}`}
            >
              <SecondaryButton className={css.seeMoreButton}>
                See more from {purchaseData.sellerName}
              </SecondaryButton>
            </a>

            {purchaseData.message && (
              <p className={css.infoMessage}>{purchaseData.message}</p>
            )}
          </h2>
        </div>
        <CartOrderSummary
          products={purchaseData.products}
          editAmount={editAmount}
          removeItem={removeItem}
          currentUser={currentUser}
          sellerName={purchaseData.sellerName}
          shippingCost={shippingCost}
          weight={weight}
          quantity={purchaseData.totalQuantity}
          currency={currency}
          intl={intl}
          sellerId={sellerId}
          country={country}
          handleOpenModal={handleOpenModal}
          subtotal={purchaseData.subtotal}
          storeName={purchaseData.sellerName}
          handleStorePurchase={handleStorePurchase}
          purchaseData={purchaseData}
        />
      </div>
    </div>
  );
}

StorePurchase.propTypes = {
  products: PropTypes.object,
  store: PropTypes.string,
  purchaseData: PropTypes.object,
  country: PropTypes.object,
  removeItem: PropTypes.func,
  editAmount: PropTypes.func,
  handleOpenModal: PropTypes.func,
  sellerId: PropTypes.string,
  intl: intlShape.isRequired,
  currency: PropTypes.string,
};

export default StorePurchase;
